<template>
    <div>
        <base-input
            v-model="name"
            validate="required"
            @keyup.enter="submit"
            label="Name"
            name="name"
            ref="name"/>

        <template v-if="show_permission">
            <label class="checkbox">
                <input
                    @input="$emit('toggle_private')"
                    v-model="topic.is_private"
                    type="checkbox"/>

                Private Topic<br/><br/>
            </label>

            <topic-members
                v-if="topic.is_private"
                :space="space"
                :topic="topic"/><br/>
        </template>

        <base-button
            :loading="loading"
            @click="submit"
            class="is-primary"
            icon="fas fa-check"
            text="Save"/>&nbsp;

        <base-button
            :loading="loading"
            @click="$emit('cancel')"
            class="is-danger"
            icon="fas fa-times"
            text="Close"/>
    </div>
</template>

<script>
import TopicMembers from './TopicMembers.vue';

export default {
    components: { TopicMembers },
    props: ['space', 'topic', 'show_permission', 'init_data', 'loading'],
    data() {
        return this.init_data || { name: '' };
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$emit('submit', { name: this.name });
            });
        },
    },
};
</script>
